import { styled } from '@vw-marketing/us-components';

export const StyledFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  margin-top: ${(props) => props.theme.size.static400};
`;

export const StyledInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 32px;
  & [class^='StyledLabel-'],
  & [class*=' StyledLabel-'] {
    & [class^='StyledTextComponent-'],
    & [class*=' StyledTextComponent-'] {
      display: block;
    }
  }
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
`;
